import React, { Component } from 'react';
import { changeColorTint } from '../../../styles/utils';
import moment from 'moment';

class TurfListItem extends Component {
  render() {
    let { data, focused, id } = this.props;

    return (
      <div
        className={`side-menu-list-obj ${focused && 'focused'}`}
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}
        id={id}
        onClick={this.props.onTitleClick}
      >
        {/*inner wrapper to generate side color border*/}
        <div className="list-obj-inner-wrapper" style={{ borderLeftColor: data.color }}>
          <div className="obj-title" onClick={this.props.onTitleClick}>
            {data.turf_name}
          </div>
          {data.comments && <div className="obj-data">{data.comments}</div>}
          <div className="obj-data">{data.targethouseholds.length} Doors</div>
          {data.lastname && !this.props.hideAssignment && (
            <div className="obj-data primary-text">
              Assigned to: {data.firstname} {data.lastname}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default TurfListItem;
